module.exports = {
  en: {
    descricaoTitulo: `
    Let's get to know a little of my history?`,
    descricao2: `
    It all started in 2016, where I passed the entrance exam in analysis and
    systems development at IFPR (Federal Institute of Paraná). Without any basis for programming logic. But through
    college that I understood the whole concept for this giant world of
    technology, from practice to the labor market.`,
    descricao3: `
    My first year of college I already started working as a support
    IT, in my second year I actually entered the battlefield as
    intern and started working with programming in java.`,
    descricao4: `Parallel to the college / internship I participated in several events of
    technology / innovation and entrepreneurship like Hackathons and startup
    weekend. In the last year of college I went to several companies
    as an intern and learned a lot. (Java, Sptring, javascript,
    Angular, React, SQL, Tests, GIT, Scrum, Linux, ...)`,
    descricao5: `I currently work with the Javascript and Java stack. I like a lot
    work as a team and create new projects, but when I'm not
    working, I like to play the guitar, read, play video games and
    watch professional cs game`,
    habilidades: `Skills`,
    projetos: `Projects`,
    contatoTitulo: `Contact`,
    contato: `You can contact me through any of the
    my social networks. Or in my email:
    lorenakauanecontato@gmail.com`,
  },
  pt: {
    descricaoTitulo: "Vamos conhecer um pouco da minha história?",
    descricao2: `Tudo começou em 2016, onde passei no vestibular em análise e
    desenvolvimento de sistemas no IFPR (Instituto Federal do paraná). Sem nenhuma base de lógica de programação. Mas através da
    faculdade que entendi todo o conceito por esse gigante mundo da
    tecnologia, da prática ao mercado de trabalho. `,
    descricao3: ` Meu primeiro ano de faculdade já comecei a trabalhar como suporte
    de TI, em meu segundo ano entrei de fato no campo de batalha como
    estagiária e comecei trabalhar com programação em java.`,
    descricao4: `Paralelo à faculdade/estágio participei de diversos eventos de
    tecnologia/inovação e empreendedorismo como Hackathons e startup
    weekend. No último ano de faculdade passei por diversas empresas
    como estagiária e aprendi muito. (Java, Sptring, javascript,
    Angular, React, SQL, Testes, GIT, Scrum, Linux, ... )`,
    descricao5: `Atualmente trabalho com a stack Javascript e com Java. Gosto muito de
    trabalhar em equipe e criar novos projetos, mas quando não estou
    trabalhando, gosto de tocar violão, ler, jogar videogame e
    assistir jogo de cs profissional`,
    habilidades: "Habilidades",
    projetos: "Projetos",
    contatoTitulo: "Contato",
    contato: `Você pode entrar em contato comigo através de qualquer uma das
    minhas redes sociais. Ou no meu e-mail:
    lorenakauanecontato@gmail.com`,
  },
}
